<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre13" id="pgepubid00025">TO<br class="calibre21"/>
SIR WALTER GRINDLAY SIMPSON, BART.</h2>
<p class="calibre7"><i class="calibre22">My dear Cigarette</i>,</p>
<p class="calibre7"><i class="calibre22">It was enough that you should have shared so liberally in
the rains and portages of our voyage</i>; <i class="calibre22">that you should have
had so hard a paddle to recover the derelict</i>
‘<i class="calibre22">Arethusa</i>’ <i class="calibre22">on the flooded Oise</i>; <i class="calibre22">and
that you should thenceforth have piloted a mere wreck of mankind
to Origny Sainte-Benoîte and a supper so eagerly
desired</i>.  <i class="calibre22">It was perhaps more than enough</i>, <i class="calibre22">as
you once somewhat piteously complained</i>, <i class="calibre22">that I should have
set down all the strong language to you</i>, <i class="calibre22">and kept the
appropriate reflexions for myself</i>.  <i class="calibre22">I could not in
decency expose you to share the disgrace of another and more
public shipwreck</i>.  <i class="calibre22">But now that this voyage of ours
is going into a cheap edition</i>, <i class="calibre22">that peril</i>, <i class="calibre22">we shall
hope</i>, <i class="calibre22">is at an end</i>, <i class="calibre22">and I may put your name on the
burgee</i>.</p>
<p class="calibre7"><i class="calibre22">But I cannot pause till I have lamented the fate of our two
ships</i>.  <i class="calibre22">That</i>, <i class="calibre22">sir</i>, <i class="calibre22">was not a fortunate
day when we projected the possession of a canal barge</i>; <i class="calibre22">it
was not a fortunate day when we shared our day-dream with the
most hopeful of day-dreamers</i>.  <i class="calibre22">For a while</i>,
<i class="calibre22">indeed</i>, <i class="calibre22">the world looked smilingly</i>.  <i class="calibre22">The
barge was procured and christened</i>, <i class="calibre22">and as the</i>
‘<i class="calibre22">Eleven Thousand Virgins of Cologne</i>,’ <i class="calibre22">lay
for some months</i>, <i class="calibre22">the admired of all admirers</i>, <i class="calibre22">in a
pleasant river and under the walls of an ancient town</i>. 
<i class="calibre22">M. Mattras</i>, <i class="calibre22">the accomplished carpenter of Moret</i>,
<i class="calibre22">had made her a centre of emulous labour</i>; <i class="calibre22">and you will
not have forgotten the amount of sweet champagne consumed in the
inn at the bridge end</i>, <i class="calibre22">to give zeal to the workmen and
speed to the work</i>.  <i class="calibre22">On the financial aspect</i>, <i class="calibre22">I
would not willingly dwell</i>.  <i class="calibre22">The</i> ‘<i class="calibre22">Eleven
Thousand Virgins of Cologne</i>’ <i class="calibre22">rotted in the stream
where she was beautified</i>.  <i class="calibre22">She felt not the impulse
of the breeze</i>; <i class="calibre22">she was never harnessed to the patient
track-horse</i>.  <i class="calibre22">And when at length she was sold</i>,
<i class="calibre22">by the indignant carpenter of Moret</i>, <i class="calibre22">there were sold
along with her the</i> ‘<i class="calibre22">Arethusa</i>’ <i class="calibre22">and
the</i> ‘<i class="calibre22">Cigarette</i>,’ <i class="calibre22">she of cedar</i>,
<i class="calibre22">she</i>, <i class="calibre22">as we knew so keenly on a portage</i>, <i class="calibre22">of
solid-hearted English oak</i>.  <i class="calibre22">Now these historic
vessels fly the tricolor and are known by new and alien
names</i>.</p>
<p class="calibre12"><i class="calibre22">R. L. S.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?4a51a179